import ClaimCard from "./ClaimCard";
export default ClaimCard;
